module.exports = __webpack_public_path__ + "static/media/ESS_pump.ea30e5b2.jpg";